function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "w4k5a",
  d: "M821.75 647.04c0 40.284-45.555 72.94-101.75 72.94s-101.75-32.656-101.75-72.94S663.805 574.1 720 574.1s101.75 32.656 101.75 72.94z"
}), React.createElement("path", {
  id: "w4k5b",
  d: "M720.495 712.416c-38.018 0-68.95-31.139-68.95-69.411 0-38.272 30.932-69.41 68.95-69.41s68.95 31.138 68.95 69.41c0 38.272-30.932 69.41-68.95 69.41zM720.5 566c-42.182 0-76.5 34.542-76.5 77s34.318 77 76.5 77 76.5-34.542 76.5-77-34.318-77-76.5-77z"
}), React.createElement("path", {
  id: "w4k5c",
  d: "M700.456 624h7.088c8.508-10.333-8.506-20.667 0-31h-7.088c-8.508 10.332 8.508 20.667 0 31z"
}), React.createElement("path", {
  id: "w4k5d",
  d: "M717.456 624h7.089c8.506-10.333-8.507-20.667 0-31h-7.09c-8.506 10.332 8.508 20.667 0 31z"
}), React.createElement("path", {
  id: "w4k5e",
  d: "M733.455 624h7.09c8.506-10.333-8.508-20.667 0-31h-7.09c-8.506 10.332 8.507 20.667 0 31z"
}), React.createElement("path", {
  id: "w4k5f",
  d: "M744.275 681.38h-47.156c-2.281 0-4.136-1.868-4.136-4.163v-27.945h55.428v27.945c0 2.295-1.855 4.163-4.136 4.163zm-55.807-44.757h64.46a2.51 2.51 0 0 1 2.499 2.514 2.51 2.51 0 0 1-2.499 2.514h-64.46a2.51 2.51 0 0 1-2.498-2.514 2.509 2.509 0 0 1 2.498-2.514zm74.218 16.474l-6.7 1.739v-6.046a10.144 10.144 0 0 0 7.015-9.654c0-5.59-4.519-10.136-10.074-10.136h-64.459c-5.555 0-10.073 4.548-10.073 10.136 0 4.515 2.951 8.346 7.014 9.654v5.89l-6.095-1.583c-2.702-.701-5.456.932-6.153 3.65-.696 2.718.927 5.488 3.629 6.19l8.62 2.238v12.04c0 6.498 5.253 11.785 11.71 11.785h47.156c6.458 0 11.711-5.287 11.711-11.784V665.33l9.223-2.394c2.702-.702 4.325-3.472 3.629-6.19-.7-2.718-3.457-4.351-6.153-3.65z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  opacity: 0.7,
  transform: "rotate(14 2710.85 -2119.742)"
}, React.createElement("use", {
  fill: "#effff6",
  xlinkHref: "#w4k5a"
})), React.createElement("g", {
  transform: "translate(-613 -566)"
}, React.createElement("use", {
  fill: "#7d8998",
  xlinkHref: "#w4k5b"
})), React.createElement("g", {
  transform: "translate(-613 -566)"
}, React.createElement("use", {
  fill: "#7d8998",
  xlinkHref: "#w4k5c"
})), React.createElement("g", {
  transform: "translate(-613 -566)"
}, React.createElement("use", {
  fill: "#7d8998",
  xlinkHref: "#w4k5d"
})), React.createElement("g", {
  transform: "translate(-613 -566)"
}, React.createElement("use", {
  fill: "#7d8998",
  xlinkHref: "#w4k5e"
})), React.createElement("g", {
  transform: "translate(-613 -566)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#w4k5f"
})));

var SvgChangeConfirm = function SvgChangeConfirm(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 199,
    height: 172,
    viewBox: "0 0 199 172",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChangeConfirm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/changeConfirm.53b673eb.svg";
export { ForwardRef as ReactComponent };